export default {
  // Page titles
  'pages.log.rawIngestion.title': 'Upload Payloads',
  'pages.log.rawIngestion.subtitle':
    'Raw arrival records of client uplink data (captured on receipt, including malformed/rejected payloads); view raw payloads, download originals, and replay them into the sync pipeline',

  // Table columns
  'pages.log.rawIngestion.column.receivedAt': 'Received At',
  'pages.log.rawIngestion.column.receivedAtRange': 'Received At Range',
  'pages.log.rawIngestion.column.batchNo': 'Batch No.',
  'pages.log.rawIngestion.column.batchNo.placeholder': 'Exact match',
  'pages.log.rawIngestion.column.batchNo.copy': 'Copy batch No.',
  'pages.log.rawIngestion.column.batchNo.copied': 'Copied',
  'pages.log.rawIngestion.column.endpoint': 'Endpoint',
  'pages.log.rawIngestion.column.tenant': 'Tenant',
  'pages.log.rawIngestion.column.store': 'Store',
  'pages.log.rawIngestion.column.tenant.placeholder':
    'Select a tenant (searchable)',
  'pages.log.rawIngestion.column.store.placeholder':
    'Select a store (searchable)',
  'pages.log.rawIngestion.column.store.placeholderFirst':
    'Select a tenant first',
  'pages.log.rawIngestion.column.device': 'Device',
  'pages.log.rawIngestion.column.device.copy': 'Copy Device ID',
  'pages.log.rawIngestion.column.device.copied': 'Copied',
  'pages.log.rawIngestion.column.size': 'Payload Size',
  'pages.log.rawIngestion.column.uploadCount': 'Upload Count',
  'pages.log.rawIngestion.column.lastUploadedAt': 'Last Upload At',
  'pages.log.rawIngestion.column.uploadCountMin': 'Upload Count Greater Than',
  'pages.log.rawIngestion.column.uploadCountMin.placeholder':
    'Enter a count (strictly greater than)',
  'pages.log.rawIngestion.column.parseStatus': 'Status',
  'pages.log.rawIngestion.column.rejectReason': 'Reject Reason',
  'pages.log.rawIngestion.column.action': 'Actions',

  // Common placeholders / hints
  'pages.log.rawIngestion.placeholder.select': 'Select an option',
  'pages.log.rawIngestion.tooltip.nameNotBackfilled': 'name not backfilled',
  'pages.log.rawIngestion.tooltip.uploadCountRepeat':
    'The same payload has been uploaded {count} times; possible abnormal client retry',

  // Endpoint display names (full row-render dictionary, including endpoints that
  // stopped recording at the 2026-10-20 narrowing — only order/operational batch
  // v1+v2 still capture; historical rows keep rendering until 90-day retention
  // decay, so entries stay; batch-status GETs are dynamic path segments, label
  // fallback only). The filter dropdown offers only the four capturing endpoints
  // (index.tsx endpointFilterEnum, synced 2026-10-24) — do not re-add stopped
  // endpoints to the dropdown
  'pages.log.rawIngestion.endpoint.orderBatch': 'Order Batch',
  'pages.log.rawIngestion.endpoint.operationalBatch': 'Operational Batch',
  'pages.log.rawIngestion.endpoint.memberLogs': 'Member Logs',
  'pages.log.rawIngestion.endpoint.mallUpload': 'Mall Upload',
  'pages.log.rawIngestion.endpoint.orderBatchV2': 'Order Batch (v2)',
  'pages.log.rawIngestion.endpoint.orderBatchResetV2': 'Order Batch Reset (v2)',
  'pages.log.rawIngestion.endpoint.orderBatchStatusGetV2':
    'Order Batch Status (v2)',
  'pages.log.rawIngestion.endpoint.operationalBatchV2':
    'Operational Batch (v2)',
  'pages.log.rawIngestion.endpoint.operationalBatchStatusGetV2':
    'Operational Batch Status (v2)',
  'pages.log.rawIngestion.endpoint.memberLogsV2': 'Member Logs (v2)',
  'pages.log.rawIngestion.endpoint.dataSyncStrategyV2':
    'DataSync Strategy (v2)',
  'pages.log.rawIngestion.endpoint.dataSyncSyncPageV2': 'DataSync Page (v2)',
  'pages.log.rawIngestion.endpoint.mallConfigV2': 'Mall Config (v2)',
  'pages.log.rawIngestion.endpoint.mallMergedVersionV2': 'Merged Version (v2)',
  'pages.log.rawIngestion.endpoint.mallMergedMetaV2': 'Merged Meta (v2)',
  'pages.log.rawIngestion.endpoint.mallMergedDownloadV2':
    'Merged Download (v2)',
  'pages.log.rawIngestion.endpoint.mallUploadV2': 'Mall Upload (v2)',
  'pages.log.rawIngestion.endpoint.mallSmLinesV2': 'SM Lines Upload (v2)',
  'pages.log.rawIngestion.endpoint.heartbeatV2': 'Device Heartbeat (v2)',
  'pages.log.rawIngestion.endpoint.checkUpdateV2': 'Check Update (v2)',

  // Parse status options (English aligned with backend enumPick)
  'pages.log.rawIngestion.parseStatus.captured': 'Captured',
  'pages.log.rawIngestion.parseStatus.accepted': 'Accepted',
  'pages.log.rawIngestion.parseStatus.rejected': 'Rejected',
  'pages.log.rawIngestion.parseStatus.error': 'Error',

  // Actions
  'pages.log.rawIngestion.action.detail': 'Detail',
  'pages.log.rawIngestion.action.reload': 'Reload',
  'pages.log.rawIngestion.action.reload.confirmTitle': 'Confirm Reload',
  'pages.log.rawIngestion.action.reload.confirmDesc':
    'This will take the original payload and replay it into the sync pipeline as-is (only order/operational batches are supported). Continue?',
  'pages.log.rawIngestion.action.reload.tip':
    'Replay into the sync pipeline (idempotent by batch No.)',
  'pages.log.rawIngestion.action.reload.unsupported':
    'Reload is not supported for this endpoint',

  // Messages
  'pages.log.rawIngestion.msg.loadDetailFailed': 'Failed to load detail',
  'pages.log.rawIngestion.msg.downloadFailed': 'Download failed',
  'pages.log.rawIngestion.msg.batchReloadFailed': 'Batch reload request failed',
  'pages.log.rawIngestion.msg.reloadSuccess':
    'Reload succeeded (batch no. {batchNo}, new arrival {id})',
  'pages.log.rawIngestion.msg.replayResponse':
    'Replay response: code={code} {msg}',
  'pages.log.rawIngestion.msg.unknownId': 'unknown',

  // Detail drawer
  'pages.log.rawIngestion.drawer.title': 'Arrival Detail',
  'pages.log.rawIngestion.drawer.download': 'Download Original',
  'pages.log.rawIngestion.drawer.loading': 'Loading…',
  'pages.log.rawIngestion.detail.arrivalId': 'Arrival ID',
  'pages.log.rawIngestion.detail.receivedAt': 'Received At',
  'pages.log.rawIngestion.detail.endpoint': 'Endpoint',
  'pages.log.rawIngestion.detail.tenant': 'Tenant',
  'pages.log.rawIngestion.detail.store': 'Store',
  'pages.log.rawIngestion.detail.posId': 'Device ID',
  'pages.log.rawIngestion.detail.clientIp': 'Client IP',
  'pages.log.rawIngestion.detail.bodySize': 'Payload Bytes',
  'pages.log.rawIngestion.detail.uploadCount': 'Upload Count',
  'pages.log.rawIngestion.detail.lastUploadedAt': 'Last Upload At',
  'pages.log.rawIngestion.detail.uploadHistory': 'Submission History',
  'pages.log.rawIngestion.detail.parseStatus': 'Status',
  'pages.log.rawIngestion.detail.sinkFile': 'File Location',
  'pages.log.rawIngestion.detail.rejectReason': 'Reject Reason',
  'pages.log.rawIngestion.detail.rawBody': 'Raw Payload',
  'pages.log.rawIngestion.detail.copyTruncated':
    'Copy preview (truncated; download for full text)',
  'pages.log.rawIngestion.detail.copyOriginal': 'Copy original payload',
  'pages.log.rawIngestion.detail.copied': 'Copied',
  'pages.log.rawIngestion.detail.truncatedTag':
    'Truncated at 64KB; download for full text',
  'pages.log.rawIngestion.detail.binaryTag': 'Binary payload; download to view',
  'pages.log.rawIngestion.detail.noPreviewBinary':
    'Binary payload has no text preview',
  'pages.log.rawIngestion.detail.noPreview':
    'No previewable payload (metadata-only row or archived file)',

  // ===== Batch reload (multi-select + toolbar button; per-row reuse of the single-reload semantics) =====
  'pages.log.rawIngestion.batchReload.button': 'Batch Reload',
  'pages.log.rawIngestion.batchReload.maxHint':
    'At most 50 rows per batch reload; reduce the selection and retry',
  'pages.log.rawIngestion.batchReload.nothingReloadable':
    'None of the selected rows support reload (endpoints outside the order/operational batch set); adjust the selection',
  'pages.log.rawIngestion.batchReload.confirmTitle': 'Confirm Batch Reload',
  'pages.log.rawIngestion.batchReload.confirmContent':
    '{total} rows selected, of which {reloadable} are reloadable (order/operational batch endpoints); the replay re-enters the sync pipeline idempotently by batch No. and produces new arrival rows and derived batch numbers. Continue?',
  'pages.log.rawIngestion.batchReload.resultTitle': 'Batch Reload Result',
  'pages.log.rawIngestion.batchReload.confirm': 'OK',
  'pages.log.rawIngestion.batchReload.cancel': 'Cancel',
  'pages.log.rawIngestion.batchReload.resultSummary':
    'Succeeded {success} / Failed {fail}',
  'pages.log.rawIngestion.batchReload.successHint':
    'A successful reload produces new arrival rows and derived batch numbers; the list has been refreshed',
  // Failed-detail modal columns (batch No. as primary key, id as diagnostic aid)
  'pages.log.rawIngestion.batchReload.column.batchNo': 'Batch No.',
  'pages.log.rawIngestion.batchReload.column.id': 'Arrival ID',
  'pages.log.rawIngestion.batchReload.column.reason': 'Failure Reason',
  'pages.log.rawIngestion.batchReload.failedTitle': 'Failed Rows',
};
